import React, { useMemo } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFilePdf,
  faCamera,
  faDraftingCompass,
  faCubes,
  faFileAlt,
  faEye,
  faDownload,
  faPen
} from "@fortawesome/free-solid-svg-icons";

export default function AssetDocumentsPanel(props) {

  var data = props.data;

  var documents = useMemo(function () {
    return data && data.length ? data : buildDemoDocuments();
  }, [data]);

  function getTypeIcon(doc) {
    if (doc.type === "PDF") return faFilePdf;
    if (doc.type === "SCAN") return faCamera;
    if (doc.type === "DWG") return faDraftingCompass;
    if (doc.type === "RVT") return faCubes;
    return faFileAlt;
  }

  function renderHeader() {
    return (
      <div style={styles.header}>
        <div style={styles.title}>Documents</div>
        <div style={styles.subtitle}>
          Certificates, drawings, scans & supporting files
        </div>
      </div>
    );
  }

  function renderTableHeader() {
    return (
      <div style={styles.tableHeader}>
        <div style={styles.colIcon}></div>
        <div style={styles.colName}>File Name</div>
        <div style={styles.colType}>Type</div>
        <div style={styles.colSupplier}>Supplier</div>
        <div style={styles.colDate}>Date</div>
        <div style={styles.colActions}>Actions</div>
      </div>
    );
  }

  function renderRow(doc) {
    return (
      <div key={doc.id} style={styles.row}>
        <div style={styles.colIcon}>
          <FontAwesomeIcon icon={getTypeIcon(doc)} />
        </div>

        <div style={styles.colName}>
          <div style={styles.fileName}>{doc.fileName}</div>
        </div>

        <div style={styles.colType}>{doc.type}</div>
        <div style={styles.colSupplier}>{doc.supplier}</div>
        <div style={styles.colDate}>{doc.date}</div>

        <div style={styles.colActions}>
          <button style={styles.iconBtn}>
            <FontAwesomeIcon icon={faEye} />
          </button>
          <button style={styles.iconBtn}>
            <FontAwesomeIcon icon={faDownload} />
          </button>
          <button style={styles.iconBtn}>
            <FontAwesomeIcon icon={faPen} />
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.outer}>
      {renderHeader()}
      <div style={styles.table}>
        {renderTableHeader()}
        {documents.map(function (doc) {
          return renderRow(doc);
        })}
      </div>
    </div>
  );
}

/* ---------------- Demo Data ---------------- */

function buildDemoDocuments() {
  return [
    makeDoc("1", "PAT_Certificate_Desk_RF08.pdf", "PDF", "ABC Compliance", "12 Jun 2025"),
    makeDoc("2", "Fixed_Electrical_Report.pdf", "PDF", "XYZ Electrical", "03 Mar 2024"),
    makeDoc("3", "Desk_Photo_Install.jpg", "SCAN", "Facilities", "01 Aug 2025"),
    makeDoc("4", "Floor_Layout_Level01.dwg", "DWG", "Design Team", "19 May 2025"),
    makeDoc("5", "HQ_Building_Model.rvt", "RVT", "Architect", "15 Feb 2025")
  ];
}

function makeDoc(id, fileName, type, supplier, date) {
  return {
    id: id,
    fileName: fileName,
    type: type,
    supplier: supplier,
    date: date
  };
}

/* ---------------- Styles ---------------- */

var styles = {
  outer: {
    background: "#f2f4f7",
    borderRadius: "10px",
    border: "1px solid #dcdcdc",
    overflow: "hidden",
    fontFamily: "Arial, sans-serif"
  },

  header: {
    padding: "14px",
    borderBottom: "1px solid rgba(0,0,0,0.1)",
    background: "linear-gradient(180deg, rgba(66,133,244,1) 0%, rgba(30,88,182,1) 100%)"
  },

  title: {
    fontSize: "14px",
    fontWeight: "bold",
    color: "#ffffff"
  },

  subtitle: {
    fontSize: "11px",
    color: "rgba(255,255,255,0.85)",
    marginTop: "4px"
  },

  table: {
    padding: "10px"
  },

  tableHeader: {
    display: "flex",
    padding: "8px 10px",
    fontSize: "11px",
    fontWeight: "bold",
    color: "#666",
    borderBottom: "1px solid #ddd"
  },

  row: {
    display: "flex",
    alignItems: "center",
    padding: "12px 10px",
    background: "#ffffff",
    borderBottom: "1px solid #e6e6e6",
    fontSize: "12px",
    color: "#222"
  },

  colIcon: {
    width: "40px",
    textAlign: "center",
    color: "#1e58b6",
    fontSize: "14px"
  },

  colName: { flex: 1 },
  colType: { width: "80px" },
  colSupplier: { width: "160px" },
  colDate: { width: "110px" },

  colActions: {
    width: "130px",
    display: "flex",
    gap: "8px",
    justifyContent: "flex-end"
  },

  fileName: {
    fontWeight: "bold",
    fontSize: "12px"
  },

  iconBtn: {
    border: "none",
    background: "linear-gradient(180deg, rgba(66,133,244,1) 0%, rgba(30,88,182,1) 100%)",
    borderRadius: "6px",
    width: "30px",
    height: "30px",
    cursor: "pointer",
    color: "#ffffff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }
};
